import React from 'react';
import { Input } from '../../../components/tailwind/input';
import { Card, CardContent } from '../../../components/tailwind/card';
import RequiredAsterisk from '../../../components/shared/RequiredAsterisk';
import MediaSelector from '../../../components/whatsapp/templates/MediaSelector';
import { SendTemplateMediaUploader } from '../../../components/whatsapp/send-message/SendTemplateMediaUploader';
import { VariableSampleRow } from '../TemplateUtils';
import ButtonsSection from './ButtonsSection';

export default function RegularTemplateForm({
  formData,
  setFormData,
  validationErrors,
  headerVars,
  bodyVars,
  sampleValues,
  sampleErrors,
  handleSampleChange,
  sampleValidationMessage,
  localHeaderError,
  localBodyError,
  handleHeaderTextChange,
}) {
  return (
    <Card className="border-gray-200 dark:border-slate-800 bg-white dark:bg-slate-900">
      <CardContent className="p-6 space-y-6">
        <div className="space-y-3">
          <label className="text-sm font-medium text-gray-900 dark:text-white">
            Header <span className="text-gray-400 font-normal">(Optional)</span>
          </label>

          <div className="space-y-2">
            <Input
              placeholder="Enter header text..."
              className={`w-full bg-gray-50 dark:bg-slate-950 text-gray-900 dark:text-white ${
                localHeaderError || validationErrors.headerText ? 'border-red-500 focus-visible:ring-red-500' : ''
              }`}
              value={formData.headerText}
              onChange={(e) => handleHeaderTextChange(e.target.value)}
              maxLength={60}
            />
            {(localHeaderError || validationErrors.headerText) && (
              <p className="text-xs text-red-500">{localHeaderError || validationErrors.headerText}</p>
            )}
          </div>
        </div>

        <p className="text-xs text-gray-500 dark:text-gray-400">Note: You can add either a header or media, but not both</p>

        <MediaSelector disabled={!!(formData.headerText && formData.headerText.trim())} />

        {(formData.headerType === 'document' || formData.headerType === 'audio') && (
          <div className="mt-4">
            <SendTemplateMediaUploader
              headerType={formData.headerType}
              mode="create"
              disabled={!!(formData.headerText && formData.headerText.trim())}
            />
          </div>
        )}

        <div className="h-px bg-gray-100 dark:bg-slate-800" />

        <div className="space-y-3">
          <label className="text-sm font-medium text-gray-700 dark:text-gray-300">
            Body <RequiredAsterisk />
          </label>
          <textarea
            className={`flex min-h-[120px] w-full rounded-md border bg-gray-50 dark:bg-slate-950 px-3 py-2 text-sm text-gray-900 dark:text-white ring-offset-background placeholder:text-muted-foreground focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-offset-2 disabled:cursor-not-allowed disabled:opacity-50 resize-none font-sans ${
              localBodyError || validationErrors.bodyText
                ? 'border-red-500 focus-visible:ring-red-500'
                : 'border-gray-200 dark:border-slate-800 focus-visible:ring-emerald-500'
            }`}
            placeholder="Enter your message text here... use {{variable_name}} for variables."
            value={formData.bodyText}
            onChange={(e) => setFormData('bodyText', e.target.value)}
          />
          {(localBodyError || validationErrors.bodyText) && (
            <p className="text-xs text-red-500">{localBodyError || validationErrors.bodyText}</p>
          )}
        </div>

        {(headerVars && headerVars.length > 0) || (bodyVars && bodyVars.length > 0) ? (
          <div className="p-4 border rounded-md bg-gray-50 dark:bg-slate-950 border-gray-200 dark:border-slate-700">
            <h4 className="text-sm font-medium text-gray-900 dark:text-white mb-2">Variable samples</h4>
            <p className="text-xs text-gray-500 mb-4">
              Include samples of all variables in your message to help Meta review your template. Remember not to include any customer information to protect your customer's privacy.
            </p>

            {headerVars && headerVars.length > 0 && (
              <div className="mb-3">
                <p className="text-xs font-medium text-gray-700 mb-2">Header</p>
                <div className="space-y-2">
                  {headerVars.map((v) => (
                    <VariableSampleRow
                      key={v}
                      name={v}
                      value={sampleValues[v]}
                      error={sampleErrors[v]}
                      onChange={handleSampleChange}
                    />
                  ))}
                </div>
              </div>
            )}

            {bodyVars && bodyVars.length > 0 && (
              <div>
                <p className="text-xs font-medium text-gray-700 mb-2">Body</p>
                <div className="space-y-2">
                  {bodyVars.map((v) => (
                    <VariableSampleRow
                      key={v}
                      name={v}
                      value={sampleValues[v]}
                      error={sampleErrors[v]}
                      onChange={handleSampleChange}
                    />
                  ))}
                </div>
              </div>
            )}
          </div>
        ) : null}

        {sampleValidationMessage && <p className="text-sm text-red-500">{sampleValidationMessage}</p>}

        {!false && (
          <div>
            <ButtonsSection formData={formData} setFormData={setFormData} validationErrors={validationErrors} />
          </div>
        )}

        <div className="h-px bg-gray-100 dark:bg-slate-800" />
      </CardContent>
    </Card>
  );
}
